import React from "react";
import { MapPin, Phone, Mail, Loader, Send } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center h-full min-h-[400px] p-8 text-center bg-slate-50 border border-slate-100 animate-in fade-in zoom-in duration-500">
        <div className="w-16 h-16 mb-6 rounded-lg bg-green-100 flex items-center justify-center">
          <Send className="w-8 h-8 text-green-600" />
        </div>
        <h3 className="text-2xl font-bold text-slate-900 mb-2">Gửi thành công!</h3>
        <p className="text-slate-600 max-w-md mx-auto mb-8">{successMessage}</p>
        <Button onClick={() => window.location.reload()} variant="outline" className="rounded-md border-slate-900 text-slate-900 hover:bg-slate-900/5 transition-colors">
          Gửi tin nhắn khác
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Vui lòng nhập họ và tên"
      }} render={({
        field
      }) => <FormItem className="relative space-y-0">
              <FormControl>
                <Input placeholder=" " {...field} className="peer h-14 px-4 pt-4 pb-1 rounded-md border-slate-200 bg-transparent focus-visible:ring-1 focus-visible:ring-[var(--color-ring)] focus-visible:border-[var(--color-ring)] transition-all" />
              </FormControl>
              <FormLabel className="absolute left-4 top-4 text-slate-400 duration-200 transform -translate-y-3 scale-75 origin-[0] z-10 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[var(--color-ring)] cursor-text">
                Họ và Tên <span className="text-red-500">*</span>
              </FormLabel>
              <FormMessage className="text-xs mt-1" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Vui lòng nhập email",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Email không hợp lệ"
        }
      }} render={({
        field
      }) => <FormItem className="relative space-y-0">
              <FormControl>
                <Input type="email" placeholder=" " {...field} className="peer h-14 px-4 pt-4 pb-1 rounded-md border-slate-200 bg-transparent focus-visible:ring-1 focus-visible:ring-[var(--color-ring)] focus-visible:border-[var(--color-ring)] transition-all" />
              </FormControl>
              <FormLabel className="absolute left-4 top-4 text-slate-400 duration-200 transform -translate-y-3 scale-75 origin-[0] z-10 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[var(--color-ring)] cursor-text">
                Địa chỉ Email <span className="text-red-500">*</span>
              </FormLabel>
              <FormMessage className="text-xs mt-1" />
            </FormItem>} />
      </div>

      <FormField control={control} name="subject" rules={{
      required: "Vui lòng nhập tiêu đề"
    }} render={({
      field
    }) => <FormItem className="relative space-y-0">
            <FormControl>
              <Input placeholder=" " {...field} className="peer h-14 px-4 pt-4 pb-1 rounded-md border-slate-200 bg-transparent focus-visible:ring-1 focus-visible:ring-[var(--color-ring)] focus-visible:border-[var(--color-ring)] transition-all" />
            </FormControl>
            <FormLabel className="absolute left-4 top-4 text-slate-400 duration-200 transform -translate-y-3 scale-75 origin-[0] z-10 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[var(--color-ring)] cursor-text">
              Tiêu đề <span className="text-red-500">*</span>
            </FormLabel>
            <FormMessage className="text-xs mt-1" />
          </FormItem>} />

      <FormField control={control} name="content" rules={{
      required: "Vui lòng nhập nội dung liên hệ"
    }} render={({
      field
    }) => <FormItem className="relative space-y-0">
            <FormControl>
              <Textarea placeholder=" " {...field} className="peer min-h-[120px] px-4 pt-6 pb-2 rounded-md border-slate-200 bg-transparent focus-visible:ring-1 focus-visible:ring-[var(--color-ring)] focus-visible:border-[var(--color-ring)] transition-all resize-none" />
            </FormControl>
            <FormLabel className="absolute left-4 top-4 text-slate-400 duration-200 transform -translate-y-3 scale-75 origin-[0] z-10 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[var(--color-ring)] cursor-text">
              Nội Dung Liên Hệ <span className="text-red-500">*</span>
            </FormLabel>
            <FormMessage className="text-xs mt-1" />
          </FormItem>} />

      {submitError && <div className="p-3 bg-red-50 border border-red-100 text-red-600 text-sm rounded-md">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 rounded-md bg-[var(--color-primary)] hover:bg-[var(--color-primary)]/90 text-white font-semibold text-base tracking-wide shadow-md transition-all">
        {isSubmitting ? <>
            <Loader className="mr-2 h-4 w-4 animate-spin" />
            Đang gửi...
          </> : "Gửi Thông Tin"}
      </Button>
    </Form>;
}
export default function GuiThongTinLienHe() {
  return <section id="gửi-thông-tin-liên-hệ" className="w-full bg-white">
      <div className="flex flex-col min-h-[600px]">
        <div className="w-full bg-white p-8 lg:p-20 flex flex-col justify-center items-center">
          <div className="max-w-xl mx-auto w-full">
            <div className="mb-12 text-center">
              <h2 className="text-3xl lg:text-5xl font-extrabold text-[var(--color-primary)] mb-4 tracking-tighter">
                Gửi Thông Tin Liên Hệ
              </h2>
              <p className="text-slate-500 text-lg font-medium">
                Kết nối với đội ngũ chuyên gia NUCETECH để nhận hỗ trợ kỹ thuật và tư vấn giải pháp.
              </p>
            </div>

            <FormProvider formId="contact_form_contact" sectionName="contact_section" defaultValues={{
            name: "",
            email: "",
            subject: "",
            content: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            subject: {
              required: true
            },
            content: {
              required: true
            }
          }} submitText="Gửi Thông Tin" successMessage="Cảm ơn bạn đã liên hệ với NUCETECH. Chúng tôi sẽ phản hồi sớm nhất có thể." errorMessage="Đã có lỗi xảy ra. Vui lòng thử lại sau." className="w-full">
              <ContactForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}